// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "./Navbar.css";

export default function Navbar() {
  const { user, profile, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <Link to="/" className="nav-logo">
        <span className="oni-glyph">鬼</span>
        <span className="brand-text">TAKKYU ONI</span>
      </Link>

      <button className="burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
        <span /><span /><span />
      </button>

      <div className={`nav-links${menuOpen ? " open" : ""}`}>
        <NavLink to="/awaken" className={({isActive}) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
          RÉVEIL
        </NavLink>
        <NavLink to="/lore" className={({isActive}) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
          LORE
        </NavLink>
        <NavLink to="/shop" className={({isActive}) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
          SHOP
        </NavLink>
        <NavLink to="/about" className={({isActive}) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
          FONDATEURS
        </NavLink>

        {user ? (
          <>
            <NavLink to="/profile" className={({isActive}) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
              MON DÉMON
            </NavLink>
            <button className="nav-link nav-logout" onClick={handleLogout}>
              SORTIR
            </button>
          </>
        ) : (
          <Link to="/auth" className="btn btn-primary btn-sm" onClick={() => setMenuOpen(false)}>
            ENTRER
          </Link>
        )}
      </div>
    </nav>
  );
}
